export default "__VITE_ASSET__CfO8vAQt__"